<template>
    <div class="experiment-card">
      <h2>{{ title }}</h2>
      <p>{{ description }}</p>
      <a :href="link" class="button">Перейти</a>
    </div>
  </template>
  
  <script>
  export default {
    name: "ExperimentCard",
    props: {
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      link: {
        type: String,
        required: true,
      },
    },
  };
  </script>
  
  <style scoped>
  .experiment-card {
    background-color: #f9fff9;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 15px;
    margin: 10px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    width: 100%;
    min-height: 100px;
  }
  .experiment-card h2 {
    margin: 0;
    color: #000;
  }
  .experiment-card p {
    color: #666;
    margin: 5px 0 15px;
  }
  .experiment-card .button {
    color: #0c0;
    text-decoration: none;
    font-weight: bold;
  }
  .experiment-card .button:hover {
    text-decoration: underline;
  }
  </style>
  